<template>
  <div class="Lcl-List">
    <common-header></common-header>
    <back-top></back-top>
    <Search>
      <template slot="Search-col">
        <div class="Search-item">
          <span>始发站</span>
          <div class="Lcl-input">
            <i>A</i>
            <el-select 
              v-model="startCity" 
              filterable
              remote
              :remote-method="remotePol" 
              clearable
              placeholder="选择始发站"
              @focus="getRailPolData(searchPolText, 1)"
            >
              <el-option 
                v-for="s in polArr" 
                :key="s.F_Id" 
                :value="s.F_Id" 
                :label="s.F_NameEN + ' ' + '(' + s.F_NameCN + ' ' + '|' + ' ' + s.F_CountryName + ')'"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="Search-item">
          <span>目的站国家/地区</span>
          <div class="Lcl-input">
            <i>B</i>
            <el-select 
              v-model="fclCity" 
              filterable
              remote
              clearable
              placeholder="选择目的站国家/地区"
              @focus="getPolCountryData"
              @change="handlerChangeCountry"
            >
              <el-option 
                v-for="e in polCountryArr" 
                :key="e.F_Id" 
                :value="e.F_Id" 
                :label="e.F_CountryEnglishName + ' ' + e.F_CountryName"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="Search-item">
          <span>目的站</span>
          <div class="Lcl-input">
            <i>C</i>
            <el-select 
              v-model="endCity" 
              filterable
              remote
              :remote-method="remotePod"  
              clearable
              placeholder="选择目的站"
              @focus="getRailPodData(searchPodText, 2)"
              
            >
              <el-option 
                v-for="e in podArr" 
                :key="e.F_Id" 
                :value="e.F_Id" 
                :label="e.F_NameEN + ' ' + '(' + e.F_NameCN + ' ' + '|' + ' ' + e.F_CountryName + ')'"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-button
          style="background: #0081ff"
          class="Search-btn"
          type="primary"
          icon="el-icon-search"
          @click="debounceMethods"
        >
        </el-button>
      </template>
    </Search>
    <!-- 筛选 -->
    
    <Data-Rail-list>
      <!-- 分页 -->
      <div class="pagesBox" slot="pageContent">
        <el-pagination
          layout="total,prev,pager,next"
          :total="total"
          :current-page="currentPage"
          :page-size="pageSize"
          @current-change="handleCurrentChange"  
        >
        </el-pagination>
      </div>
    </Data-Rail-list>
    <Contact></Contact>
    <Tencent></Tencent>
    <Common-Footer></Common-Footer>
    <Type-Tag :bgColor="bgColor">
      <div slot="slot-text">铁路出口整箱</div>
    </Type-Tag>
  </div>
</template>

<script>
import CommonHeader from '@/components/Header/CommonHeader'
import CommonFooter from '@/components/Footer/CommonFooter'
import TypeTag from '@/components/TypeTag/TypeTag'
import Search from '@/components/Search/Search'
import DataRailList from '@/components/DataList/DataRailList'
import Contact from '@/components/Contact/Contact'
import BackTop from '@/components/BackTop/BackTop'
import Tencent from '@/components/Tencent/Tencent'

// 导入pubsub
import pubsub from 'pubsub-js'
import _ from 'lodash'

export default {
  name: 'FclList',
  data() {
    return {
      fclCity: '', //目的港国家/地区
      startCity: '', //起运港
      endCity: '', //目的港
      consignee: '', //收货人类型
      shipCompany: '', //船公司,
      schedule: '', //班期
      transportType: '', //类型
      transitPort: '', //中转港
      polPort: '', //起运港码头
      podPort: '', //目的港码头
      codeNumber: '',
      boxCon: '',
      bgColor: '#70b0c4',
      searchPolText: '',
      searchPodText: '',

      polArr: [], //起运港列表
      podArr: [], //目的港列表
      filterData: [], //收货人列表
      transportTypeArr: [{id: 1, name: '直达'}, {id: 2, name: '中转'}],
      currentPage: 1,
      week: [{id: '一', name: '周一'}, {id: '二', name: '周二'}, {id: '三', name: '周三'}, {id: '四', name: '周四'}, {id: '五', name: '周五'}, {id: '六', name: '周六'}, {id: '七', name: '周日'}],
      containerArr: [{id: 1, text: 'COC'}, {id: 2, text: 'SOC'}],
      total: 0, // 总条数
      currentPage: 0,
      pageSize: 0,
      consigneeArr: [], //收货人类型列表
      polCountryArr: [] //目的港国家/地区列表
    }
  },

  created() {
    this.startCity = this.$route.params.railStartCity
    this.endCity = this.$route.params.railEndCity
    this.fclCity = this.$route.params.railCountryCity
    this.searchPolText = this.$route.params.searchRailPol
    this.searchPodText = this.$route.params.searchRailPod

    // 调用港口列表
    this.getRailPolData('', 1)
    this.getRailPodData('', 2)
    this.getPolCountryData()
  },

  mounted() {
    //调用查询列表
    this.getRailFclListData(this.currentPage)
    this.getConsigneeListData()
  },

  methods: {
     // 跳转页面
     handleCurrentChange(newPage) {
      this.getFclListData(newPage)
    },

    remotePol(query) {
      this.getRailPolData(query, 1)
    },

    remotePod(query) {
      this.getRailPodData(query, 2)
    },

      // 获取查询数据
    async getRailFclListData(page) {
      const {data: res} = await this.$http.post('RailExportfcl/index', {
        Page: page,
        From: this.startCity,
        To: this.endCity,
        ShopCompany	: this.shipCompany,
        ShiftPeriod: this.schedule,
        Sstate: this.transportType,
        Transit: this.transitPort,
        FromQuay: this.polPort,
        ToQuay: this.podPort,
        RouteCode: this.codeNumber,
        Ceratina: this.boxCon,
        CountryId: this.fclCity,
        Ctype: this.consignee
      })
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.total = res.data.total
        this.currentPage = res.data.current_page
        this.pageSize = res.data.per_page
        pubsub.publish('sendListData', res.data)
      }catch(error) {
        console.log(error)
      }      
    },

    // 获取始发站数据
    async getRailPolData(data, type) {
      const {data: res} = await this.$http.post('Data/getRailStation', {
        Type: type,
        Flag: 1,
        SearchText: data? data : ''
      })
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.polArr = res.data.data
      }
      catch(error) {
        console.log(error)
      }
    },

    // 获取目的站数据
    async getRailPodData(data, type) {
      const {data: res} = await this.$http.post('Data/getRailStation', {
        Type: type,
        Flag: 1,
        SearchText: data? data : '',
        CountryId: this.fclCity? this.fclCity : ''
      })
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.podArr = res.data.data
      }
      catch(error) {
        console.log(error)
      }
    },

    // 获取目的港国家/地区数据
    async getPolCountryData() {
      const {data: res} = await this.$http.post('Data/getCountry')
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.polCountryArr = res.data
      }catch(error) {
        console.log(error)
      }
    },

    handlerChangeCountry() {
      this.endCity = ''
    },

    // handlerChangeEndCity() {
    //   this.fclCity = ''
    // },

    // 筛选数据
    async getFilterListData(type) {
      const {data: res} = await this.$http.post('Data/getExFclPortStore', {
        Type: type
      })
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.filterData = res.data
      }catch(error) {
        console.log(error)
      }
    },

    async getConsigneeListData() {
      const {data: res} = await this.$http.post('Data/getConsigneeType')
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.consigneeArr = res.data
      }catch(error) {
        console.log(error)
      }
    },

    // 防抖
    debounceMethods:  _.debounce(function() {
      this.getRailFclListData()
    }, 500),

    // 船公司筛选
    // handlerFilterShip() {
    //   this.$nextTick(() => {
    //     this.shipCompany = this.$refs.ship.selectedLabel
    //     this.getFclListData()
    //   })
    // },

    // // 班期筛选
    // handlerFilterSchedule() {
    //   this.getFclListData()
    // },

    // // 筛选运输方式
    // handlerFilterType() {
    //   this.getFclListData()
    // },

    // // 筛选中转码头
    // handlerFilterTrans() {
    //   this.getFclListData()
    // },

    // handlerFilterConsignee(e) {
    //   this.getFclListData()
    //   // console.log(e)
    // },

    // 筛选起运港码头
    // handlerFilterPol() {
    //   this.getFclListData()
    // },

    // 筛选目的港码头
    // handlerFilterPod() {
    //   this.getFclListData()
    // },

    // 筛选航线代码
    // handlerFilterCode() {
    //   this.getFclListData()
    // },

    // 筛选箱属
    handlerFilterContainer() {
      this.$nextTick(() => {
        this.boxCon = this.$refs.box.selectedLabel
        this.getFclListData()
      })   
    }
  },

  components: {
    CommonHeader,
    CommonFooter,
    Search,
    DataRailList,
    Contact,
    TypeTag,
    BackTop,
    Tencent
  }
}
</script>


<style scoped lang="less">
.Search-item {
  width: 32.5%;

  .Lcl-input {
    display: flex;
    align-items: center;

    i {
      width: 50px;
      background: #fff;
      height: 48px;
      line-height: 48px;
      text-align: center;
      color: #555;
      font-weight: 550;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }

    .el-select {
      width: 100%;

      /deep/ .el-input__icon {
        line-height: 50px;
      }
    }

    ::v-deep .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  span {
    font-size: 13px;
    color: #697e9d;
    margin-bottom: 6px;
  }

  ::v-deep .el-input__inner {
    height: 50px;
  }
}

.Filters {
  display: flex;
  width: 1280px;
  margin: 0 auto;
  background: #fff;
  // box-shadow: 5px 5px 20px #e1e1e1;
  padding: 12px 15px;
  align-items: center;
  box-sizing: border-box;
  position: sticky;
  top: 230px;
  z-index: 100;
  box-shadow: 5px 5px 10px #e1e1e1;

  .Filters-l {
    width: 5%;
    .Filters-item-icon {
      display: flex;
      align-items: center;
      color: #0081ff;
      font-size: 15px;
    }
  }

  .Filters-r {
    display: flex;
    width: 95%;
    justify-content: space-between;
    .Filters-item {
      width: 16%; 
      .Filters-item-input {
        width: 100%;
      } 
    }
  }
}
</style>